export const REACT_APP_HOST = process.env.REACT_APP_BASE_URL;
export const REACT_API_VERSION = '/api/v1/';